<template>
  <div id="iapsz_list">
    <template>
      <div>
        <v-data-table
          :options.sync="options"
          :server-items-length="totalItems"
          :headers="headers"
          :items="forms"
          :search="search_form"
          :loading="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50, 100],
          }"
          :items-per-page="50"
          class="elevation-1"
        >
          <template v-slot:top>
            <!-- <v-subheader>Zoznam IAPSZ Formulárov</v-subheader>
            <v-divider></v-divider> -->

            <v-layout class="pa-3">
              <v-text-field
                v-model="search_form"
                label="Vyhľadať"
              />
              <v-switch
                v-if="user_type == 'default' || user_type == 'admin'"
                v-model="zivy_stav_only"
                class="pl-5"
                label="Iba živý stav"
              />
              <v-switch
                v-model="active_only"
                class="pl-5"
                label="Iba aktívne"
              />
            </v-layout>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              small
              class="mr-3"
              @click="editItem(item)"
            >
              mdi-eye
            </v-icon>
            <v-icon
              small
              class="mr-3"
              @click="historyItem(item)"
            >
              mdi-account-badge-outline
            </v-icon>
            <v-icon
              v-if="canDelete(item)"
              small
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:item.closed="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <span v-if="item.closed">Archivované/Uzavreté</span>
              <span v-else>Aktívne</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-btn
          fab
          bottom
          left
          color="pink"
          dark
          fixed
          @click="dialog = !dialog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </template>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title>Nový IAPSZ formulár</v-card-title>
        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="item_new.prisoner"
                item-text="string_details"
                item-value="id"
                prepend-icon="mdi-email"
                placeholder="Základné číslo"
                label="Základné číslo"
                :items="prisoners"
                auto-select-first
                :search-input.sync="search"
                cache-items
                :loading="loading_prisoners"
                hide-no-data
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >
            Zrušiť
          </v-btn>
          <v-btn
            text
            @click="createIapsz()"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
import auth from "@/api/auth";
import { mapGetters } from "vuex";

const apiService = new APIService();

export default {
  data: () => ({
    sortBy: "id",
    sortDesc: false,

    timeout: null,
    active_only: true,
    zivy_stav_only: true,
    dialog: false,
    loading: true,
    loading_prisoners: false,
    search_form: "",
    search: null,
    totalItems: 0,
    options: {},

    forms: [],

    item_new: {
      prisoner: "",
      spracovatelia: [],
      spracovatelia_upsvar: []
    },
    prisoners: [],
  }),

  computed: {
    ...mapGetters("auth", ["user_type"]),

    headers: function () {
      if (this.forms.length < 1) {
        return
      }

      if ('base_number' in this.forms[0].prisoner_full) {
        return [
          {
            text: "Interné ID",
            value: "id",
          },
          { text: "Základné číslo", value: "prisoner_full.base_number" },
          { text: "Meno", value: "prisoner_full.name_full" },
          { text: "Ústav", value: "prisoner_full.institution_full.name" },
          { text: "Vytvorený", value: "created_at" },
          { text: "Posledná zmena", value: "updated_at" },
          { text: "Stav", value: "closed" },
          { text: "Akcie", value: "action", sortable: false },
        ]

      }
      return [
        {
          text: "Interné ID",
          value: "id",
        },
        { text: "Dátum narodenia", value: "prisoner_full.birth_date" },
        { text: "Meno", value: "prisoner_full.name_full" },
        { text: "Ústav", value: "prisoner_full.institution_full.name" },
        { text: "Vytvorený", value: "created_at" },
        { text: "Posledná zmena", value: "updated_at" },
        { text: "Stav", value: "closed" },
        { text: "Akcie", value: "action", sortable: false },
      ]
    }
  },

  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    active_only() {
      this.getDataFromApi();
    },
    zivy_stav_only() {
      this.getDataFromApi();
    },
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },
  created() {
    // this.querySelections("");

    auth.getAccountDetails().then((response) => {
      this.user_pk = response.data.pk;
    });
  },

  methods: {
    canDelete(item) {
      if (item.permissions.delete) return true;

      return false;
    },

    getClosed(item) {
      if (item == true) return "uzavretý";
      else return "otvorený";
    },
    getColor(item) {
      if (item == true) return "white";
      else return "red";
    },

    createIapsz() {
      apiService.createIapsz(this.item_new).then(
        (response) => {
          this.dialog = false;
          this.$router.push({
            name: "iapsz_udaje_o_klientovi",
            params: { id: response.id },
          });
        },
      );
    },

    getIapszForms(sort, search, limit, offset, filters) {
      this.loading = true;

      apiService
        .getIapszForms(sort, search, limit, offset, filters)
        .then((response) => {
          this.forms = response.results;
          this.totalItems = response.count;
          this.loading = false;
        });
    },

    editItem(item) {
      this.$router.push({
        name: "iapsz_udaje_o_klientovi",
        params: { id: item.id },
      });
    },

    historyItem(item) {
      this.$router.push({ name: "iapsz_history", params: { id: item.id } });
    },

    async deleteItem(item) {
      confirm("Naozaj chcete zmazať?") &&
        apiService.deleteIapszForm(item).then(() => {
          const index = this.forms.indexOf(item);
          this.forms.splice(index, 1);
        });
    },

    querySelections(v) {
      this.loading_prisoners = true;

      apiService.searchPrisoners(v).then((response) => {
        this.prisoners = response.results;
        this.loading_prisoners = false;
      });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0].replace(/\./g, "__").replace(/_full/g, "");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      let filters = [];
      if (this.active_only) {
        filters.push(["closed",
          false])
      }

      if (this.user_type != 'upsvar' && this.zivy_stav_only) {
        filters.push(["prisoner__zivy_stav", true])
      }

      this.getIapszForms(sort, this.search_form, itemsPerPage, offset, filters);
    },
  },
};
</script>